import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Indicator } from '../../models/indicator';
import { CrudService } from '../crud.service';
import { lastValueFrom, Observable } from 'rxjs';
import { Category } from '../../models/category';

@Injectable({
  providedIn: 'root',
})
export class IndicatorService extends CrudService<Indicator> {
  protected basePath = 'indicator'; // Specific for IndicatorService
  public instanceType = 'indicator'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }

  updateLockStatus(ids: string[], isLocked: boolean): Observable<Indicator> {
    if (isLocked) {
      return this.http.put<Indicator>(`${this.getBaseUrl()}/lockMany`, ids);
    } else {
      return this.http.put<Indicator>(`${this.getBaseUrl()}/unlockMany`, ids);
    }
  }

  /**
   * overwrite updateMultiple - invoke persistMany instead for indicators
   * @param items
   */
  override updateMultiple(items: Indicator[]): Observable<Indicator> {
    return this.http.post<Indicator>(`${this.getBaseUrl()}/persistMany`, items);
  }

  /**
   * overwrite updateMultiple - invoke persistMany instead for indicators
   * @param items
   */
  override insertMultiple(items: Indicator[]): Observable<Indicator> {
    return this.http.post<Indicator>(`${this.getBaseUrl()}/persistMany`, items);
  }

  async getPoolAsPromise() {
    return await lastValueFrom(
      this.http.get<Indicator[]>(`${this.getBaseUrl()}/pool`)
    );
  }

  getImportUrl() {
    return `${this.getBaseUrl()}/convertXlsxToJson`;
  }

  convertToXlsx(indicators: any) {
    return this.http.post(
      `${this.getBaseUrl()}/convertJsonToXlsx`,
      indicators,
      {
        responseType: 'blob',
      }
    );
  }

  async getByCategoryIds(categoryIds: string[]) {
    const headers = new HttpHeaders({
      'X-Category-Ids': JSON.stringify(categoryIds),
    });
    return await lastValueFrom(
      this.http.get<{ [key: string]: Indicator }>(
        `${this.getBaseUrl()}/categories`,
        { headers: headers }
      )
    );
  }
}
